import React, { useEffect, useMemo, useState } from "react";
import { exportVote, StuVoteItem, VoteContent } from "service/vote";
import style from "./index.module.scss";
import Statics from "../Statics";
import _ from "underscore";
import useQuery from "utils/useQuery";
import VoteStuTable from "./components/VoteStuTable";
import InputSearch from "components/CourseComponents/InputSearch";
import { Button, Icon } from "antd";

interface VoteResultProps {
    data: VoteContent;
    stuList: StuVoteItem[];
}

export default function VoteResult({ data, stuList }: VoteResultProps) {
    const { status: defaultStatus } = useQuery<{ status: string }>();
    const [status, setStatus] = useState(defaultStatus || "all");
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        if (!defaultStatus) return;
        setStatus(defaultStatus);
    }, [defaultStatus]);

    // 筛选的列表
    const filteredList = useMemo(() => {
        return stuList
            .filter(
                item =>
                    item.name.indexOf(searchText) !== -1 ||
                    item.studentNo === searchText
            )
            .filter(item => {
                // 投票状态
                if (status === "all") return true;
                if (status === "vote" && item.voteStatus === "1") return true;
                return status === "unVote" && item.voteStatus === "0";
            });
    }, [searchText, status, stuList]);

    // 统计数据
    const statics = useMemo(() => {
        return _.reduce(
            stuList,
            (memo, item) => ({
                courseStuCount: memo.courseStuCount + 1,
                voteStuCount:
                    memo.voteStuCount + (item.voteStatus === "1" ? 1 : 0),
                notVoteStuCount:
                    memo.notVoteStuCount + (item.voteStatus === "0" ? 1 : 0)
            }),
            { courseStuCount: 0, voteStuCount: 0, notVoteStuCount: 0 }
        );
    }, [stuList]);

    return (
        <div className={style.root}>
            <div className={style.header}>
                <Statics current={status} onChange={setStatus} {...statics} />

                <div>
                    <div className={style.exportText}>
                        参与率 {data.percentage}
                    </div>
                    <Button
                        type="primary"
                        ghost
                        className={style.exportButton}
                        onClick={() => exportVote(data.id)}>
                        <Icon type="cloud-download" /> 导出数据
                    </Button>
                </div>
            </div>

            <div className={style.search}>
                <InputSearch
                    onChange={setSearchText}
                    placeholder="输入姓名、学号查看学生的投票状态"
                />
            </div>

            <div className={style.body}>
                <VoteStuTable stuList={filteredList} voteInfo={data} />
            </div>
        </div>
    );
}
